import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '@/app/shared/components/loader/loader.component';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, LoaderComponent],
    template: `
        <max-loader></max-loader>
        <router-outlet></router-outlet>
    `
})
export class AppComponent {}
